import { Languages } from "lucide-react";
import { useI18n, type Lang } from "@/i18n";
import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";

/** Nome de cada idioma no próprio idioma (não se traduz). */
const LANGS: { value: Lang; short: string; name: string }[] = [
  { value: "pt-BR", short: "PT", name: "Português (Brasil)" },
  { value: "en", short: "EN", name: "English" },
];

/** Troca rápida de idioma (barra lateral e telas públicas), ao lado do ThemeToggle. */
export function LanguageToggle() {
  const { t, lang, setLang } = useI18n();
  const current = LANGS.find((l) => l.value === lang) ?? LANGS[0]!;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1 px-2" aria-label={t("common.languageCurrent", { lang: current.name })}>
          <Languages aria-hidden />
          <span aria-hidden>{current.short}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.value} lang={l.value} onSelect={() => setLang(l.value)} className={lang === l.value ? "font-semibold" : undefined}>
            {l.name}
            {lang === l.value && <span className="ml-auto size-1.5 rounded-full bg-primary" aria-hidden />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
